module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro"
  }, [_c('div', {
    staticClass: "cuadro-content"
  }, [_c('div', {
    staticClass: "cuadro-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "cuadro-number"
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2464dcb0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/c_info_card.vue
// module id = 840
// module chunks = 0